import { CALL_API } from '../middleware/ApiMiddleware';

export const HTML_FORM_IMAGE_LIST_FETCH_REQUEST = 'HTML_FORM_IMAGE_LIST_FETCH_REQUEST';
export const HTML_FORM_IMAGE_LIST_FETCH_SUCCESS = 'HTML_FORM_IMAGE_LIST_FETCH_SUCCESS';
export const HTML_FORM_IMAGE_LIST_FETCH_FAILURE = 'HTML_FORM_IMAGE_LIST_FETCH_FAILURE';

export const HTML_FORM_IMAGES_FETCH_REQUEST = 'HTML_FORM_IMAGES_FETCH_REQUEST';
export const HTML_FORM_IMAGES_FETCH_SUCCESS = 'HTML_FORM_IMAGES_FETCH_SUCCESS';
export const HTML_FORM_IMAGES_FETCH_FAILURE = 'HTML_FORM_IMAGES_FETCH_FAILURE';

export const HTML_FORM_IMAGES_EDIT_REQUEST = 'HTML_FORM_IMAGES_EDIT_REQUEST';
export const HTML_FORM_IMAGES_EDIT_SUCCESS = 'HTML_FORM_IMAGES_EDIT_SUCCESS';
export const HTML_FORM_IMAGES_EDIT_FAILURE = 'HTML_FORM_IMAGES_EDIT_FAILURE';

export const HTML_FORM_IMAGES_CREATE_REQUEST = 'HTML_FORM_IMAGES_CREATE_REQUEST';
export const HTML_FORM_IMAGES_CREATE_SUCCESS = 'HTML_FORM_IMAGES_CREATE_SUCCESS';
export const HTML_FORM_IMAGES_CREATE_FAILURE = 'HTML_FORM_IMAGES_CREATE_FAILURE';

export const HTML_FORM_IMAGE_DELETE_REQUEST = 'HTML_FORM_IMAGE_DELETE_REQUEST';
export const HTML_FORM_IMAGE_DELETE_SUCCESS = 'HTML_FORM_IMAGE_DELETE_FAILURE';
export const HTML_FORM_IMAGE_DELETE_FAILURE = 'HTML_FORM_IMAGE_DELETE_FAILURE';

// This should be an unified API supporting multiple products
const baseURL = 'xerce/config/html-form-images';

export const fetchHTMLFormImages = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [HTML_FORM_IMAGE_LIST_FETCH_REQUEST, HTML_FORM_IMAGE_LIST_FETCH_SUCCESS, HTML_FORM_IMAGE_LIST_FETCH_FAILURE],
  },
});

export const fetchHTMLFormImage = (htmlFormImageId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${htmlFormImageId}`,
    method: 'get',
    authenticated: true,
    types: [HTML_FORM_IMAGES_FETCH_REQUEST, HTML_FORM_IMAGES_FETCH_SUCCESS, HTML_FORM_IMAGES_FETCH_FAILURE],
  },
});

export const editHTMLFormImage = (htmlFormImageEditRequest: IHTMLFormImageEditRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}`,
    method: 'put',
    body: htmlFormImageEditRequest,
    authenticated: true,
    types: [HTML_FORM_IMAGES_EDIT_REQUEST, HTML_FORM_IMAGES_EDIT_SUCCESS, HTML_FORM_IMAGES_EDIT_FAILURE],
  },
});

export const createHTMLFormImage = (htmlFormImageRequest: IHTMLFormImageRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: htmlFormImageRequest,
    authenticated: true,
    types: [HTML_FORM_IMAGES_CREATE_REQUEST, HTML_FORM_IMAGES_CREATE_SUCCESS, HTML_FORM_IMAGES_CREATE_FAILURE],
  },
});

export const deleteHTMLFormImage = (htmlFormImageId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${htmlFormImageId}`,
    method: 'delete',
    authenticated: true,
    types: [HTML_FORM_IMAGE_DELETE_REQUEST, HTML_FORM_IMAGE_DELETE_SUCCESS, HTML_FORM_IMAGE_DELETE_FAILURE],
  },
});
